import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {onyxLightest, white} from '/theme/color/on.color';
import {cyanBlue, graniteGray} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {
    flexDirection: 'row',
    paddingBottom: indent * 0.8,
    paddingTop: indent * 0.8,
    paddingLeft: indent * 0.8,
    paddingRight: indent * 0.4,
    backgroundColor: cyanBlue,
    marginHorizontal: -indent,
  },
  iconContainer: {
    marginRight: indent * 0.8,
    height: 34,
    borderRadius: 50,
    borderWidth: 1.5,
    backgroundColor: white,
    borderColor: onyxLightest,
  },
  icon: {
    fontSize: 20,
    padding: 5,
  },
  textContainer: {
    flex: 1,
  },
  description: {
    paddingVertical: indent * 0.4,
  },
  rightIcon: {
    color: graniteGray,
    fontSize: 18,
  },
});
